export class ProjectActivityTask {
    constructor(
        public readonly id: number,
        public description: string,
        public technicalProposalActivity: number,
        public indicatorIds: number[] = [],
        public completed: boolean = false,
    ) {}
}

export interface CreateProjectActivityTaskBody {
    description: string;
    completed?: boolean;
    technicalProposalActivity: number;
    indicatorIds?: number[];
}
